<template>
  <div v-if="canShowResult && cms">
    <v-menu v-model="showAnswers" :close-on-content-click="false" :nudge-width="200" open-on-hover offset-x>
      <div slot="activator" class="c-answers">
        <template v-if="iconType == 'check'">
          <v-icon color="clr-icon" size="20">mdi-check-outline</v-icon> {{ unixToFormat(post.result.t) }}
        </template>
        <template v-if="iconType == 'mail'">
          <v-icon color="clr-icon" size="20">mdi-email-open-outline</v-icon> {{ post.result.count }}
        </template>
      </div>

      <v-card>
        <div v-if="post.type == 'EQ'" class="c-nodata">
          {{ $T('post.enquete.no_history') }}
        </div>
        <v-list v-else-if="answers">
          <template v-for="(item, index) in answers">
            <v-list-tile avatar>
              <v-list-tile-avatar class="c-cover-40">
                <cmid-avatar :cmid="item.cmid" :cid="cid" :cms="cms" :size="40" />
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title
                  ><cm-name :cid="cid" :cmid="item.cmid" :type="type" :typeId="typeId" :cms="cms" :friends="curFriends"
                /></v-list-tile-title>
                <v-list-tile-sub-title>{{ toSubtitle(item.answer) }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
          <div v-if="answers.length == 0" class="c-nodata">
            {{ $T('common.no_data') }}
          </div>
        </v-list>
        <div v-else class="c-loading">
          <v-progress-circular indeterminate color="clr-icon"></v-progress-circular>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { CONST } from '../../constant';
import UTILS from '../../utils/utils';
import postPlugin from '../../utils/plugin/postPlugin';

export default {
  mixins: [postPlugin],
  props: {
    initPost: { type: Object, required: true },
    type: { type: String, required: false },
    typeId: { type: Number, required: false },
    friends: { type: Object, required: false },
  },
  data: function() {
    return {
      post: this.initPost,
      cms: null,
      showAnswers: false,
      curFriends: this.friends || {},
    };
  },
  mounted() {
    this.setup(this.cid);
  },
  watch: {
    initPost(n, o) {
      this.post = n;
      this.setup(n);
    },
    showAnswers(n, o) {
      if (this.post.type == 'EQ') return;
      if (n) this.loadAnswer(this.post);
    },
  },
  computed: {
    cid() {
      return this.post.community_id;
    },
    initType() {
      return this.initPost.type;
    },
    // controls 'JI', 'JA', 'FI', 'FA', 'NS', 'FL', 'SD', 'EQ', 'LF'
    canShowResult() {
      var showOnlyCompleted = ['JI', 'JA', 'FI', 'FA'].indexOf(this.initType) != -1;
      return !showOnlyCompleted || this.post.completed_at > 0;
    },
    iconType() {
      return ['JI', 'JA', 'FI', 'FA'].indexOf(this.initType) != -1 ? 'check' : 'mail';
    },
  },
  methods: {
    setup(post) {
      var cid = this.post.community_id;
      this.cms = null;
      this.answers = null;
      this.answerLoading = false;
      this.showAnswers = false;
      var self = this;
      this.getAllGroupsAndMembers(cid, function(data) {
        self.cms = data.cms;
      });
    },
    // controls 'JI', 'JA', 'FI', 'FA', 'NS', 'FL', 'SD', 'EQ', 'LF'
    toSubtitle(answer) {
      switch (this.initType) {
        case 'JI':
          return `${this.unixToDetail(answer.t)} - ${this.toJIResult(answer.r)}`;
        case 'FI':
          return `${this.unixToDetail(answer.t)} - ${this.toJIResult(answer.r)}`;
        case 'JA':
          return `${this.unixToDetail(answer.t)} - ${this.toJAResult(answer.r)}`;
        case 'FA':
          return `${this.unixToDetail(answer.t)} - ${this.toJAResult(answer.r)}`;
        case 'NS':
          return `${this.unixToDetail(answer.t)}`;
        case 'FL':
          return `${this.unixToDetail(answer.t)}`;
        case 'SD':
          return `${this.unixToDetail(answer.t)}`;
        case 'EQ':
          return `${this.unixToDetail(answer.t)}`;
        case 'LF':
          return `${this.unixToDetail(answer.t)} - ${CONST.postLifeStatus[answer.a]}`;
      }
      return '';
    },
    toJIResult(r) {
      if (r == 2) return $T('post.btn.confirmed');
      if (r == 1) return $T('button.accept');
      if (r == 0) return $T('button.decline');
      return '';
    },
    toJAResult(r) {
      if (r == 1) return $T('button.approval');
      if (r == 0) return $T('button.rejection');
      return '';
    },
  },
};
</script>
<style scoped>
.c-icon {
  height: 48px;
  padding: 10px 0;
  margin-right: 10px;
}
.c-icon img {
  width: 28px;
  height: 28px;
  filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.25));
}
.c-answers {
  display: flex;
  align-items: center;
  padding-right: 10px;
}
.c-answers i {
  margin-right: 5px;
}
.c-loading {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 10px;
}
.c-nodata {
  padding: 30px 15px !important;
}
</style>
